import React from "react";
import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";
import { NotoSansDevanagari } from "../NotoSansDevanagariUI-Regular-normal";
import { toast } from "react-toastify";
import { IP } from "../internalServer";

// 🔧 Setup font function
const setupPdfMakeFonts = () => {
  // 1. Check custom font
  if (!NotoSansDevanagari) {
    console.error("❌ Font 'NotoSansDevanagari' is undefined.");
    toast.error("Font loading failed. Please try again.");
    return false;
  }
  pdfMake.vfs = vfsFonts;
  // 3. Add custom font
  pdfMake.vfs["NotoSansDevanagari-Regular.ttf"] = NotoSansDevanagari;
  // 4. Define font families   console.log("🔁 Defining font families...");
  pdfMake.fonts = {
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Medium.ttf",
    },
    NotoSansDevanagari: {
      normal: "NotoSansDevanagari-Regular.ttf",
      bold: "NotoSansDevanagari-Regular.ttf",
    },
  };

  return true;
};

const ExportTablePDf = ({
  studentinfo = [],
  basicinfo = {},
  isAssessment = false,
  isActivity = false,
}) => {
  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const convertImageToBase64 = (url) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = () => {
        console.error(`Failed to load image: ${url}`);
        resolve(null);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };
  // 📝 Export to PDF table for homework
  const exportToPDF = async () => {
    const fontsSetupOk = setupPdfMakeFonts();
    if (!fontsSetupOk) return;

    console.log(studentinfo, "homewokr");
    const tableBody = [
      [
        { text: "Name", bold: true, color: "white" },
        { text: "Roll No", bold: true, color: "white" },
        { text: "Class", bold: true, color: "white" },
        { text: "Division", bold: true, color: "white" },
        { text: "Date Submitted", bold: true, color: "white" },
        { text: "Score", bold: true, color: "white" },
        { text: "Status", bold: true, color: "white" },
      ],
      ...studentinfo
        ?.filter((student) => student.Status !== "pending")
        .map((student) => [
          student.Name,
          student.School_Email,
          student.Class,
          student.Division,
          student.submitted_on !== "-"
            ? formatDate(student.submitted_on)
            : "Not Submitted",
          student.Status === "pending"
            ? "--"
            : `${student.Student_marks}/${student.total_marks}`,
          student.Status,
        ]),
    ];

    const UserInformation = JSON.parse(localStorage.getItem("UserInformation"));
    const content = [];

    // 🏫 School logo
    const schoolLogoUrl = `${IP}${UserInformation?.school?.profile_pic || ""}`;
    const schoolLogoBase64 = await convertImageToBase64(schoolLogoUrl);

    content.push({
      columns: [
        { width: "*", text: "" },
        {
          width: "auto",
          columnGap: 10,
          columns: [
            schoolLogoBase64
              ? { image: schoolLogoBase64, width: 50, margin: [0, 0, 10, 0] }
              : { text: "", width: 50 },
            {
              stack: [
                {
                  text: UserInformation?.school?.name || "School Name",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 8, 2],
                },
                {
                  text: "Powered By XploreSense™",
                  fontSize: 9,
                },
              ],
            },
          ],
        },
        { width: "*", text: "" },
      ],
      margin: [0, 0, 0, 10],
    });

    // 📋 Header Row
    content.push([
      {
        text: `Homework Name: ${basicinfo.homework_name || "Homework Report"}`,
        style: "header",
      },
      {
        text: `Status: ${basicinfo.status || "Completed"} | Subject: ${basicinfo.belowHeader
          } | Deadline: ${basicinfo.timeDate}`,
        margin: [0, 4, 0, 0],
      },
    ]);
    // 🔻 Divider
    content.push({
      canvas: [
        {
          type: "line",
          x1: 0,
          y1: 0,
          x2: 515,
          y2: 0,
          lineWidth: 1,
          lineColor: "black",
        },
      ],
      margin: [0, 5, 0, 10],
    });

    // 🧾 Table
    content.push({
      table: {
        headerRows: 1,
        widths: ["*", "*", "*", "*", "*", "*", "*"],
        body: tableBody,
      },
      layout: {
        fillColor: function (rowIndex) {
          return rowIndex === 0 ? "#f57c00" : null; // orange header background
        },
        hLineColor: () => "black",
        vLineColor: () => "black",
      },
    });

    const docDefinition = {
      content,
      defaultStyle: {
        font: "NotoSansDevanagari",
      },
      pageMargins: [40, 60, 40, 40],
      footer: (currentPage, pageCount) => ({
        columns: [
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "right",
            margin: [0, 0, 40, 0],
            fontSize: 8,
          },
        ],
      }),
    };

    pdfMake
      .createPdf(docDefinition)
      .download(`${basicinfo.homework_name || "Homework"}_report.pdf`);
  };

  // pdf for assessment
  const exportToPDFAssessment = async () => {
    const fontsSetupOk = setupPdfMakeFonts();
    if (!fontsSetupOk) return;

    const tableBody = [
      [
        { text: "Name", bold: true, color: "white" },
        { text: "Roll No", bold: true, color: "white" },
        { text: "Class", bold: true, color: "white" },
        { text: "Division", bold: true, color: "white" },
        { text: "Date Submitted", bold: true, color: "white" },
        { text: "Score", bold: true, color: "white" },
        { text: "Status", bold: true, color: "white" },
      ],
      ...studentinfo
        ?.filter((student) => student.currentStatus === "Submitted")
        .map((entry) => [
          { text: entry.student_id?.name || "", noWrap: false },
          { text: entry.student_id?.roll_number || "", noWrap: false },
          { text: entry.assessment_id?.standard?.name || "", noWrap: false },
          { text: entry.assessment_id?.section?.name || "", noWrap: false },
          {
            text: entry.submitted_on
              ? new Date(entry.submitted_on).toLocaleDateString("en-GB")
              : "Not Submitted",
            noWrap: false,
          },
          {
            text:
              entry?.status === "pending"
                ? "--"
                : entry?.assessment_id?.isAdaptive
                  ? entry?.ability?.toFixed(2)?.toString() || ""
                  : entry?.obtained_marks?.toString() || "",
            noWrap: false,
          },
          { text: entry.status || "", noWrap: false },
        ]),
    ];

    const UserInformation = JSON.parse(localStorage.getItem("UserInformation"));
    const content = [];

    // 🏫 School logo
    const schoolLogoUrl = `${IP}${UserInformation?.school?.profile_pic || ""}`;
    const schoolLogoBase64 = await convertImageToBase64(schoolLogoUrl);

    content.push({
      columns: [
        { width: "*", text: "" },
        {
          width: "auto",
          columnGap: 10,
          columns: [
            schoolLogoBase64
              ? { image: schoolLogoBase64, width: 50, margin: [0, 0, 20, 0] }
              : { text: "", width: 50 },
            {
              stack: [
                {
                  text: UserInformation?.school?.name || "School Name",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 8, 2],
                },
                {
                  text: "Powered By XploreSense™",
                  fontSize: 9,
                },
              ],
            },
          ],
        },
        { width: "*", text: "" },
      ],
      margin: [0, 0, 0, 10],
    });

    // 🧾 Header
    content.push([
      {
        text: `Assessment Title: ${basicinfo.name || "Assessment Report"}`,
        style: "header",
        margin: [0, 4, 0, 2],
      },
      {
        text: `Status: ${basicinfo.status || "N/A"} | Subject: ${
          basicinfo.subject?.name || "N/A"
        } | Deadline: ${
          basicinfo.deadline
            ? new Date(basicinfo.deadline).toLocaleDateString("en-GB")
            : "--/--/--"
        }`,
        margin: [0, 4, 0, 0],
      },
    ]);

    // 🔻 Divider
    content.push({
      canvas: [
        {
          type: "line",
          x1: 0,
          y1: 0,
          x2: 515,
          y2: 0,
          lineWidth: 1,
          lineColor: "black",
        },
      ],
      margin: [0, 5, 0, 10],
    });

    // 📊 Table (🔥 FIXED)
    content.push({
      alignment: "center",
      table: {
        headerRows: 1,
        widths: [90, 60, 60, 60, 80, 60, 60], // 🔥 FIX
        body: tableBody,
      },
      layout: {
        fillColor: (rowIndex) => (rowIndex === 0 ? "#f57c00" : null),
        hLineColor: () => "black",
        vLineColor: () => "black",
      },
      dontBreakRows: true, // 🔥 FIX
    });

    const docDefinition = {
      content,
      defaultStyle: {
        font: "NotoSansDevanagari",
      },
      pageMargins: [40, 60, 40, 40],
      footer: (currentPage, pageCount) => ({
        columns: [
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "right",
            margin: [0, 0, 40, 0],
            fontSize: 8,
          },
        ],
      }),
    };

    pdfMake
      .createPdf(docDefinition)
      .download(`${basicinfo.name || "Assessment"}_report.pdf`);
  };
  const exportToPDFActivity = async () => {
    console.log(studentinfo, "activity");
    console.log(basicinfo, "activitybasic");

    const fontsSetupOk = setupPdfMakeFonts();
    if (!fontsSetupOk) return;

    const tableBody = [
      [
        { text: "Name", bold: true, color: "white" },
        { text: "Roll No", bold: true, color: "white" },
        { text: "Class", bold: true, color: "white" },
        { text: "Division", bold: true, color: "white" },
        { text: "Date Submitted", bold: true, color: "white" },
        { text: "Score", bold: true, color: "white" },
        { text: "Status", bold: true, color: "white" },
      ],
      ...studentinfo
        ?.filter((student) => student.status !== "pending")
        .map((student) => [
          { text: student.student_id?.name || "--" },
          { text: student.student_id?.roll_number || "--" },
          { text: basicinfo?.standard_id?.name || "--" }, // Class
          { text: basicinfo?.section_id?.name || "--" }, // Division
          {
            text: student.submitted_on
              ? new Date(student.submitted_on).toLocaleDateString("en-GB")
              : "Not Submitted",
          },
          {
            text:
              student.status === "pending"
                ? "--"
                : `${student.obtainedMarks}/${basicinfo?.total_marks || "--"}`,
          },
          { text: student.status || "--" },
        ]),
    ];

    const UserInformation = JSON.parse(localStorage.getItem("UserInformation"));
    const schoolLogoUrl = `${IP}${UserInformation?.school?.profile_pic || ""}`;
    const schoolLogoBase64 = await convertImageToBase64(schoolLogoUrl);

    const content = [
      {
        columns: [
          { width: "*", text: "" },
          {
            width: "auto",
            columnGap: 10,
            columns: [
              schoolLogoBase64
                ? { image: schoolLogoBase64, width: 50, margin: [0, 0, 10, 0] }
                : { text: "", width: 50 },
              {
                stack: [
                  {
                    text: UserInformation?.school?.name || "School Name",
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 8, 2],
                  },
                  {
                    text: "Powered By XploreSense™",
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          { width: "*", text: "" },
        ],
        margin: [0, 0, 0, 10],
      },
      [
        {
          text: `Activity Name: ${basicinfo?.name || "Activity Report"}`,
          style: "header",
        },
        {
          text: `Status: ${basicinfo?.status || "N/A"} | Subject: ${
            basicinfo?.subject_id?.name || "N/A"
          } | Deadline: ${
            basicinfo?.deadline
              ? new Date(basicinfo.deadline).toLocaleDateString("en-GB")
              : "--/--/--"
          }`,
          margin: [0, 4, 0, 0],
        },
      ],
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: "black",
          },
        ],
        margin: [0, 5, 0, 10],
      },
      {
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*", "*", "*", "*"],
          body: tableBody,
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex === 0 ? "#f57c00" : null),
          hLineColor: () => "black",
          vLineColor: () => "black",
        },
      },
    ];

    const docDefinition = {
      content,
      defaultStyle: { font: "NotoSansDevanagari" },
      pageMargins: [40, 60, 40, 40],
      footer: (currentPage, pageCount) => ({
        columns: [
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "right",
            margin: [0, 0, 40, 0],
            fontSize: 8,
          },
        ],
      }),
    };

    pdfMake
      .createPdf(docDefinition)
      .download(`${basicinfo?.name || "Activity"}_report.pdf`);
  };

  return (
    <button
      className="hw_delet_button px-4"
      onClick={
        isAssessment
          ? exportToPDFAssessment
          : isActivity
            ? exportToPDFActivity
            : exportToPDF
      }
    >
      Export to PDF
    </button>
  );
};

export default ExportTablePDf;
